import { NgModule, Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AppointmentNotification } from '@shared/classes/appointment/appointment-notification.class';
import { APPOINTMENT_NOTIFICATION_CREATED_BY, APPOINTMENT_NOTIFICATION_TYPES } from '@shared/constants';
import { LOCALE } from '@shared/constants/locale.const';
import { SecurityService } from '@core/services/system/security.service';
import moment from 'moment';

@Pipe({ name: 'appointmentNotificationText' })
export class AppointmentNotificationTextPipe implements PipeTransform {
  private translateMap = new Map<string, string>();
  constructor(private translateSertive: TranslateService, private securityService: SecurityService) {
    this.setTranslateKey();
  }

  transform(notification: AppointmentNotification): string {
    const key = `${notification.createdBy}_${notification.type}`;
    const translateKey = this.translateMap.get(key);
    if (!translateKey) {
      return '';
    }
    const companyLocale = this.securityService.getLoggedCompanyData()?.locale;
    const { DateFormat, TimeFormat } = LOCALE;
    const params = {
      date: moment(notification.startedAt).format(DateFormat[companyLocale?.dateFormat] || DateFormat.DD_MM_YYYY_DOT),
      time: moment(notification.startedAt).format(TimeFormat[companyLocale?.timeFormat] || TimeFormat.H24),
    };
    return this.translateSertive.instant(translateKey, params);
  }

  private setTranslateKey() {
    const { CREATE, UPDATE, DELETE, CANCEL_BY_CUSTOMER, MESSAGE } = APPOINTMENT_NOTIFICATION_TYPES;
    const { EMPLOYEE, CUSTOMER } = APPOINTMENT_NOTIFICATION_CREATED_BY;
    this.translateMap.set(`${EMPLOYEE}_${CREATE}`, 'appointment_notification_create');
    this.translateMap.set(`${EMPLOYEE}_${UPDATE}`, 'appointment_notification_update');
    this.translateMap.set(`${EMPLOYEE}_${DELETE}`, 'appointment_notification_delete');
    this.translateMap.set(`${EMPLOYEE}_${CANCEL_BY_CUSTOMER}`, 'appointment_notification_cancel_by_customer');
    this.translateMap.set(`${EMPLOYEE}_${MESSAGE}`, 'appointment_notification_message');
    this.translateMap.set(`${CUSTOMER}_${CREATE}`, 'appointment_notification_create_by_customer');
    this.translateMap.set(`${CUSTOMER}_${UPDATE}`, 'appointment_notification_update');
    this.translateMap.set(`${CUSTOMER}_${DELETE}`, 'appointment_notification_delete');
    this.translateMap.set(`${CUSTOMER}_${CANCEL_BY_CUSTOMER}`, 'appointment_notification_cancel_by_customer');
    this.translateMap.set(`${CUSTOMER}_${MESSAGE}`, 'appointment_notification_message');
  }
}
@NgModule({
  declarations: [AppointmentNotificationTextPipe],
  exports: [AppointmentNotificationTextPipe],
})
export class AppointmentNotificationTextPipeModule {}
